import React from "react";

export default ({width}: any) => {
  return (
    <span style={{width}} />
  );
};